import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/privacy-policy.css';

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Urbania on Rent in Pune</title>
        <meta
          name="description"
          content="Privacy Policy for Urbania on Rent in Pune. Learn how we collect, use, and protect your personal information."
        />
        <meta
          name="keywords"
          content="Urbania on Rent in Pune, Force Urbania Rental Pune, Urbania Tempo Traveller Pune"
        />
      </Helmet>

      
<div
      className="breadcumb-wrapper"
      
      data-overlay="black"
      data-opacity="3"
    >
      <div className="container">
        <div className="breadcumb-content text-center">
          <h1 className="breadcumb-title">Privacy Policy</h1>
        </div>
      </div>
    </div>

   



      {/* Privacy Policy Content */}
      <section className="privacy-policy">
        <div className="container px-0">
          <div className="row g-0">
            <div className="col-12 col-md-7">
              <h3 className="title">Privacy Policy – Urbania on Rent in Pune</h3>


              <p>
                At <b>Urbania on Rent in Pune</b>, we value your privacy and are
                committed to protecting your personal information. This Privacy
                Policy explains how your data is collected, used, stored, and
                safeguarded when you book an Urbania vehicle or interact with our
                services.
              </p>

              <div className="section">
                <p className="highlight darkcolor">Information We Collect:</p>

                <p className="highlight darkcolor">1. Booking Information:</p>
                <p>
                  When you book a Force Urbania vehicle, we collect personal
                  details such as your name, phone number, pickup and drop
                  locations, travel dates, number of passengers, and payment
                  information.
                </p>

                <p className="highlight darkcolor">2. Travel & Itinerary Details:</p>
                <p>
                  For outstation, wedding, corporate, or group travel bookings,
                  we may collect itinerary details to provide smooth and timely
                  service.
                </p>

                <p className="highlight darkcolor">3. Website Usage Information:</p>
                <p>
                  We may collect technical information such as IP address,
                  browser type, device information, and pages visited to improve
                  our website and services.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">How We Use Your Information:</p>

                <p className="highlight darkcolor">1. Service Delivery:</p>
                <p>
                  Your information is used to confirm bookings, assign drivers,
                  plan routes, and manage Urbania rentals in Pune and nearby
                  locations.
                </p>

                <p className="highlight darkcolor">2. Customer Communication:</p>
                <p>
                  We use your contact details to share booking confirmations,
                  driver information, schedule updates, and customer support
                  assistance.
                </p>

                <p className="highlight darkcolor">3. Service Improvement:</p>
                <p>
                  Collected data helps us improve service quality, customer
                  experience, and operational efficiency.
                </p>

                <p className="highlight darkcolor">4. Marketing Communication:</p>
                <p>
                  With your consent, we may send promotional offers, discounts,
                  or service updates related to Urbania rentals in Pune.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Information Sharing:</p>

                <p className="highlight darkcolor">1. Drivers & Operations Team:</p>
                <p>
                  Essential booking details such as your name, phone number, and
                  pickup location are shared with assigned drivers to fulfill
                  your booking.
                </p>

                <p className="highlight darkcolor">2. Legal & Regulatory Requirements:</p>
                <p>
                  We may disclose personal information if required by law,
                  government authorities, or to ensure safety and legal
                  compliance.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Data Security:</p>
                <p>
                  We implement reasonable security practices to protect your
                  personal information. However, no online data transmission can
                  be guaranteed to be completely secure.
                </p>

                <p className="highlight darkcolor">Your Rights:</p>
                <p>
                  You may request access, correction, or deletion of your
                  personal data and opt out of promotional communication at any
                  time.
                </p>

                <p className="highlight darkcolor">Policy Updates:</p>
                <p>
                  This Privacy Policy may be updated periodically. Any changes
                  will be posted on this page and will apply to future bookings.
                </p>
              </div>
            </div>
          </div>

          {/* Contact Section */}
          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact
              us:
            </p>
            <ul>
              <li>
                <b>Phone:</b>{' '}
                <a href="tel:+91 9209423113">+91  9209423113</a>
              </li>
              <li>
                <b>Email:</b>{' '}
                <a href="mailto:bookings@urbaniaonrentpune.in">
                  bookings@urbaniaonrentpune.in
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
